const d3 = require("d3");
const { getCumulativeWaitingTimesPerGroup } = require("@/visualisation/graphs/waitingTimeAnimations/waitingTimeMath.js");

class ProjectVisualiser {
  constructor(graphShape) {
    this.graphShape = graphShape;
  }

  createProjectNodes(projectGroup, projectPositions){
    var rectSize = 65;
    var projectNodes = projectGroup
        .selectAll("rect")
        .data(projectPositions)
        .enter()
        .append("g")
        .attr("transform", function (d, i) {
          return "translate(" + d.x + "," + d.y + ")";
        });

      projectNodes.append("rect").attr("width", rectSize).attr("height", rectSize).attr("fill", "#B2B2B2").attr("style", "outline: thin solid black;").attr("transform", `rotate(45) translate(${-rectSize/2},${-rectSize/2}) `);
  }

}

module.exports = { ProjectVisualiser };